import React from "react";
import { useTranslation } from "react-i18next";
import { Banner } from "@shopify/polaris";

/**
 * Standalone create form retired — leave starts from completed onboarding.
 */
function JobLeaveForm() {
  const { t } = useTranslation();
  return (
    <Banner tone="info">
      {t("employment_leave_start_from_onboarding")}
    </Banner>
  );
}

export default JobLeaveForm;
